import type { FC } from 'react'
import { lazy } from 'react'
import { retryImport } from './retryImport'

export default (
  loader: () => Promise<{ [key: string]: FC }>,
  screen: string
) => {
  return lazy(() => {
    const screens = retryImport(loader).then(s => {
      const Screen = s[screen]

      return { default: Screen }
    })

    return screens
  })
}
